import React from "react";
import Popup from "./index";
import { MdCheckCircle, MdWarning, MdInfo, MdError } from "react-icons/md";

interface AlertPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  variant?: "success" | "warning" | "info" | "error";
  buttonText?: string;
}

const AlertPopup: React.FC<AlertPopupProps> = ({
  isOpen,
  onClose,
  title = "Alert",
  message,
  variant = "info",
  buttonText = "OK",
}) => {
  const getIcon = () => {
    switch (variant) {
      case "success":
        return <MdCheckCircle className="h-12 w-12 text-green-500" />;
      case "warning":
        return <MdWarning className="h-12 w-12 text-yellow-500" />;
      case "error":
        return <MdError className="h-12 w-12 text-red-500" />;
      case "info":
      default:
        return <MdInfo className="h-12 w-12 text-brand-500" />;
    }
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      showCloseButton={false}
      closeOnBackdropClick={true}
    >
      <div className="flex flex-col items-center text-center">
        {/* Icon */}
        <div className="mb-4">{getIcon()}</div>

        {/* Message */}
        <p className="mb-6 whitespace-pre-line text-base text-gray-700 dark:text-gray-300">
          {message}
        </p>

        {/* Button */}
        <button
          onClick={onClose}
          className="w-full rounded-lg bg-brand-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-brand-600"
        >
          {buttonText}
        </button>
      </div>
    </Popup>
  );
};

export default AlertPopup;
